export var PathType;
(function (PathType) {
    PathType["File"] = "FILE";
    PathType["Directory"] = "DIRECTORY";
})(PathType || (PathType = {}));
